import { ReactNode } from 'react';

export interface KeyValueListProps {
  data: KeyValuePair[];
  wrapperClasses?: string;
  showLoader?: boolean;
}

export interface KeyValuePair {
  keyText: string;
  keySubText?: string;
  valueText: ReactNode;
  valueSubText?: string;
}

export interface KeyValueItemProps extends KeyValuePair {
  showLoader?: boolean;
  itemClasses?: string;
}

export enum KeyVariant {
  H4 = 'h4'
}

export enum ValueVariant {
  P3 = 'p3'
}
